var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisplay = function SvgDisplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 53,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#display_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA007",
    fillRule: "evenodd",
    d: "M45.452 2.829c1.724 0 3.076 0 4.163.088 1.106.09 2.02.278 2.848.7a7.23 7.23 0 0 1 3.159 3.159c.422.827.609 1.741.7 2.848.088 1.086.088 2.438.088 4.163v.084c0 1.725 0 3.077-.089 4.163-.09 1.107-.277 2.02-.7 2.848a7.23 7.23 0 0 1-3.158 3.16c-.828.421-1.742.608-2.848.699-1.087.088-2.439.088-4.163.088H42.58v2.306c.785.055 1.566.178 2.335.37l1.98.495a.943.943 0 0 1-.458 1.83l-1.98-.495a11.6 11.6 0 0 0-5.64 0l-1.98.495A.943.943 0 1 1 36.38 28l1.98-.494q1.156-.289 2.335-.371v-2.306h-2.87c-1.725 0-3.077 0-4.164-.088-1.107-.09-2.02-.278-2.848-.7a7.23 7.23 0 0 1-3.16-3.159c-.42-.827-.608-1.741-.698-2.848-.089-1.086-.089-2.438-.089-4.163v-.084c0-1.725 0-3.077.089-4.163.09-1.107.277-2.021.699-2.848a7.23 7.23 0 0 1 3.159-3.16c.827-.421 1.741-.608 2.848-.699 1.087-.088 2.439-.088 4.163-.088zm-4.757 17.286c0 .52.422.943.943.943h7.543a.943.943 0 1 0 0-1.886h-7.543a.943.943 0 0 0-.943.943m-4.086 0a1.257 1.257 0 1 1-2.514 0 1.257 1.257 0 0 1 2.514 0",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#display_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    filter: "url(#display_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDC469",
    fillRule: "evenodd",
    d: "M30.24 6.638c2.76 0 4.922 0 6.661.142 1.77.145 3.233.444 4.557 1.119a11.57 11.57 0 0 1 5.054 5.054c.675 1.324.974 2.787 1.119 4.557.142 1.738.142 3.902.142 6.66v.136c0 2.76 0 4.923-.142 6.661-.145 1.77-.444 3.233-1.119 4.557a11.57 11.57 0 0 1-5.054 5.054c-1.324.675-2.787.974-4.557 1.12-1.739.141-3.902.141-6.66.141h-4.594v3.69c1.256.087 2.506.285 3.735.592l3.168.792a1.509 1.509 0 1 1-.732 2.927l-3.167-.792a18.6 18.6 0 0 0-9.026 0l-3.167.792a1.508 1.508 0 1 1-.732-2.927l3.167-.792c1.23-.307 2.48-.505 3.736-.593V41.84h-4.593c-2.76 0-4.923 0-6.661-.142-1.77-.145-3.233-.444-4.557-1.119a11.57 11.57 0 0 1-5.054-5.054C1.088 34.2.79 32.737.643 30.967.504 29.23.504 27.065.504 24.306v-.135c0-2.76 0-4.922.142-6.661.145-1.77.444-3.233 1.119-4.557A11.57 11.57 0 0 1 6.818 7.9c1.324-.675 2.786-.974 4.557-1.119 1.739-.142 3.902-.142 6.66-.142z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#display_svg__d)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M30.24 6.638c2.76 0 4.922 0 6.661.142 1.77.145 3.233.444 4.557 1.119a11.57 11.57 0 0 1 5.054 5.054c.675 1.324.974 2.787 1.119 4.557.142 1.738.142 3.902.142 6.66v.136c0 2.76 0 4.923-.142 6.661-.145 1.77-.444 3.233-1.119 4.557a11.57 11.57 0 0 1-5.054 5.054c-1.324.675-2.787.974-4.557 1.12-1.739.141-3.902.141-6.66.141h-4.594v3.69c1.256.087 2.506.285 3.735.592l3.168.792a1.509 1.509 0 1 1-.732 2.927l-3.167-.792a18.6 18.6 0 0 0-9.026 0l-3.167.792a1.508 1.508 0 1 1-.732-2.927l3.167-.792c1.23-.307 2.48-.505 3.736-.593V41.84h-4.593c-2.76 0-4.923 0-6.661-.142-1.77-.145-3.233-.444-4.557-1.119a11.57 11.57 0 0 1-5.054-5.054C1.088 34.2.79 32.737.643 30.967.504 29.23.504 27.065.504 24.306v-.135c0-2.76 0-4.922.142-6.661.145-1.77.444-3.233 1.119-4.557A11.57 11.57 0 0 1 6.818 7.9c1.324-.675 2.786-.974 4.557-1.119 1.739-.142 3.902-.142 6.66-.142z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#display_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#display_svg__f)",
    fillRule: "evenodd",
    d: "M22.63 34.296c0 .833.675 1.508 1.508 1.508h12.069a1.509 1.509 0 1 0 0-3.017h-12.07c-.832 0-1.508.676-1.508 1.509m-6.538 0a2.011 2.011 0 1 1-4.023 0 2.011 2.011 0 0 1 4.023 0",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "display_svg__d",
    x1: 0.503,
    x2: 43.606,
    y1: 6.638,
    y2: 53.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "display_svg__f",
    x1: 25.108,
    x2: 26.841,
    y1: 37.164,
    y2: 26.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "display_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.552 0h30.172v30.172H26.552z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "display_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4.224h48.276V52.5H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "display_svg__c",
    width: 96.77,
    height: 92.748,
    x: -24.247,
    y: -18.112,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_53_2927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_53_2927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "display_svg__e",
    width: 38.67,
    height: 17.046,
    x: 8.813,
    y: 29.029,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.256,
    dy: 3.256
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.256
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.811765 0 0 0 0 0.431373 0 0 0 0 0.156863 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53_2927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_53_2927",
    result: "shape"
  })))));
};
export { SvgDisplay as ReactComponent };